import * as React from "react";

interface Props<T> {
  defaultValue: T;
  storageKey: string;
  converter?: (value: any) => T;
  onChange?: (value: T) => void;
}
export function useSavedValue<T>({
  defaultValue,
  storageKey,
  onChange,
  converter = (value: any) => value as T,
}: Props<T>): [T, React.Dispatch<React.SetStateAction<T>>] {
  function getDefaultValue() {
    try {
      return converter(localStorage.getItem(storageKey) || defaultValue);
    } catch (e) {
      console.error("Failed to convert value to T in useSavedValue");
      return defaultValue;
    }
  }
  const [value, setValue] = React.useState<T>(getDefaultValue());
  React.useEffect(() => {
    onChange?.call(onChange, value);
  }, [value]);

  React.useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }, [value]);

  return [value, setValue];
}
